import axios from "@/lib/axios";

export const getTeamMembersApi = (ENTITY, page, perPage, search ="") => axios.get(`/api/${ENTITY}/team-members`, {
    params: {
        page,
        per_page: perPage,
        search,
    },
});
export const getTeamMembersRoles = () => axios.get(`/api/roles`);
export const removeTeamMember = (ENTITY, id) => axios.delete(`/api/${ENTITY}/team-members/${id}`);
export const changeRole = (ENTITY, id) => axios.post(`/api/${ENTITY}/team-members/${id}`);
export const updateRole = (ENTITY, id, payload) => axios.put(`/api/${ENTITY}/team-members/${id}`, payload);
export const updateTeamMembersApi = (ENTITY) => axios.get(`/api/${ENTITY}`);
export const inviteUserApi = (ENTITY, payload) => axios.post(`/api/${ENTITY}/user-invites`, payload);
export const getUserInvitesApi = (ENTITY, page, perPage, search = "") => axios.get(`/api/${ENTITY}/user-invites`, {
    params: {
        page,
        per_page: perPage,
        search,
    },
});
export const resendInviteApi = (ENTITY, id) => axios.post(`/api/${ENTITY}/user-invites/${id}/resend`);
export const deleteInviteApi = (ENTITY, id) => axios.delete(`/api/${ENTITY}/user-invites/${id}`);
export const viewInviteApi = (ENTITY, token) => axios.get(`/api/${ENTITY}/user-invites/${token}`);
export const dashboardApi = (ENTITY) => axios.get(`/api/${ENTITY}/dashboard`);
export const getEntity = (ENTITY) => axios.get(`/api/${ENTITY}`);
export const updateEntity = (ENTITY,payload) => axios.put(`/api/${ENTITY}`,payload);
export const changeLogoApi = async (ENTITY, file) => {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await axios.post(`/api/${ENTITY}/logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;

};

export const createEntity = (payload) => axios.post('/api/entities', payload);

export const userUpdate = (id, payload) => axios.put(`/api/user/${id}`, payload);
